import React, { Component } from 'react';
import { notify } from '../utils';
import { Emitter, Routing } from '../core';
import { ROLE_GUEST } from './constants';
import theme from './theme';

/* Show Xanta website */
class Main extends Component {
    render() {
        const Provider = this.props.useHashRouter ? Routing.HashRouter : Routing;
        return (
            <Provider
                roles={[ ROLE_GUEST ]}
                routes={theme.routes()}
                errorPage403={() => {
                    return this.renderError403();
                }}
                errorPage404={() => {
                    return this.renderError404();
                }}
            />
        );
    }

    renderError403() {
        return <span>{'403'}</span>;
    }

    renderError404() {
        return <span>{'404'}</span>;
    }
}

/*
 *	Listeners
 */

const msgSocket = (msg) => {
    notify.show(msg, 'success', 5000);
};

Emitter.on('@connect_error', () => {
    msgSocket('[ERREUR] Connexion en temps réel rompu avec le serveur.');
});
Emitter.on('@disconnect', () => {
    msgSocket('[INFO] Déconnexion du temps réel avec le serveur.');
});
Emitter.on('@reconnect', () => {
    msgSocket('[OK] Connexion en temps réel rétablie avec le serveur.');
});
Emitter.on('@connect', () => {
    msgSocket('[OK] Connexion en temps réel établie avec le serveur.');
});

/* History : navigation */
Emitter.on('openLink', (link) => {
    console.log('openLink', link); // TODO: DELETE
    // customHistory.push(link[0]);
});

export default Main;